class Footer extends HTMLElement {
    constructor() {
        super();
        
        this.consentOpen = false;
    }

    connectedCallback() {
        let links = document.querySelectorAll('.footer-link-title')
        links.forEach(function (link) {
            link.addEventListener('click', function () {
                link.classList.toggle('active')
                link.closest('div').querySelector('ul').classList.toggle('hidden')
            })
        })

        document.addEventListener('click', (e) => {
            const trigger = e.target.closest('[data-polaris-open-consent-modal]');
          
            if (!trigger) return;
          
            e.preventDefault();
          
            if (window.polaris?.openConsentModal) {
                if (!this.consentOpen) {
                    window.polaris.openConsentModal();
                    this.consentOpen = true;
                } else {
                    window.polaris.closeConsentModal();
                    this.consentOpen = false;
                }
            }
        });
    }
}

customElements.define('footer-block', Footer);